/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Send_Us_An_EmailInputs */

const en_mobile_send_us_an_email = /** @type {(inputs: Mobile_Send_Us_An_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send us an email`)
};

const es_mobile_send_us_an_email = /** @type {(inputs: Mobile_Send_Us_An_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envíanos un correo electrónico`)
};

/**
* | output |
* | --- |
* | "Send us an email" |
*
* @param {Mobile_Send_Us_An_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_send_us_an_email = /** @type {((inputs?: Mobile_Send_Us_An_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Send_Us_An_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_send_us_an_email(inputs)
	return en_mobile_send_us_an_email(inputs)
});